"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const copyToClipboard_1 = __importDefault(require("../../utils/copyToClipboard"));
const Copy = ({ children, text: textToCopy, hint = 'Copy to clipboard', successHint = 'Copied!', onCopy = copyToClipboard_1.default, }) => {
    const [text, setText] = (0, react_1.useState)(hint);
    const handleCopy = (0, react_1.useCallback)((directText) => {
        onCopy(textToCopy || directText);
        setText(successHint);
    }, [textToCopy, onCopy]);
    (0, react_1.useEffect)(() => {
        let timeout;
        if (text === successHint) {
            timeout = setTimeout(() => {
                setText(hint);
            }, 1000);
        }
        return () => {
            clearTimeout(timeout);
        };
    }, [text]);
    return children({ hint: text, onCopy: handleCopy });
};
exports.default = Copy;
